import React from 'react';
import { BlogPost, BlogCategory, BlogTag } from '../../types';
import BlogCard from '../BlogCard/BlogCard';
import './BlogFeed.css';

interface BlogFeedProps {
  posts: BlogPost[];
  categories: BlogCategory[];
  tags: BlogTag[];
  isLoading?: boolean;
  error?: string | null;
  itemsPerPage?: number;
}

const BlogFeed: React.FC<BlogFeedProps> = ({
  posts,
  categories,
  tags,
  isLoading = false,
  error = null,
  itemsPerPage = 6
}) => {
  const handlePostClick = (post: BlogPost) => {
    // This would typically navigate to the post detail page
    console.log('Navigate to post:', post.slug);
    // window.location.href = `/blog/${post.slug}`;
  };

  if (error) {
    return (
      <div className="blog-feed__error">
        <h2>Algo salió mal</h2>
        <p>{error}</p>
      </div>
    );
  }

  return (
    <div className="blog-feed">
      <div className="blog-feed__container">
        {isLoading ? (
          <div className="blog-feed__loading">
            <div className="blog-feed__loading-grid">
              {Array.from({ length: 6 }).map((_, index) => (
                <div key={index} className="blog-feed__loading-card">
                  <div className="blog-feed__loading-image"></div>
                  <div className="blog-feed__loading-content">
                    <div className="blog-feed__loading-text"></div>
                    <div className="blog-feed__loading-text"></div>
                    <div className="blog-feed__loading-text short"></div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ) : (
          <div className="blog-feed__grid">
            {posts.slice(0, itemsPerPage).map(post => (
              <BlogCard
                key={post.id}
                post={post}
                onClick={handlePostClick}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default BlogFeed;
